import { Stack } from "@mui/material";

/** 상단 계정 컨트롤을 좁은 화면에서도 한 줄로 유지한다. */
export const AccountButtonLayout = ({ children }) => (
  <Stack
    data-account-button-layout
    direction="row"
    alignItems="center"
    justifyContent="flex-start"
    spacing={{ xs: 0.5, sm: 1, lg: 2 }}
    flexWrap="nowrap"
    sx={{ minWidth: 0 }}
  >
    {children}
  </Stack>
);
